import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "../firebaseConfig";

let currentToken = null;
let currentUid = null;
let listenersRegistered = false;

export const inicializarPushNotifications = async (uid, navigate) => {
  if (!Capacitor.isNativePlatform() || !uid) return;
  currentUid = uid;

  try {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === "prompt") {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== "granted") {
      console.warn("Permiso de notificaciones push no otorgado:", permStatus.receive);
      return;
    }

    if (!listenersRegistered) {
      listenersRegistered = true;

      await PushNotifications.addListener("registration", async (token) => {
        currentToken = token.value;
        if (currentUid && currentToken) {
          try {
            await updateDoc(doc(db, "roles", currentUid), {
              fcmTokens: arrayUnion(currentToken),
            });
          } catch (e) {
            console.error("Error guardando FCM token en Firestore:", e);
          }
        }
      });

      await PushNotifications.addListener("registrationError", (err) => {
        console.error("Error al registrar notificaciones push:", err);
      });

      await PushNotifications.addListener("pushNotificationReceived", (notification) => {
        console.log("Notificación push recibida en foreground:", notification);
      });

      await PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
        const enlace = action.notification?.data?.enlace;
        if (enlace) {
          if (typeof navigate === "function") {
            navigate(enlace);
          } else {
            window.location.pathname = enlace;
          }
        }
      });
    }

    await PushNotifications.register();
  } catch (error) {
    console.error("Error inicializando push notifications:", error);
  }
};

export const desregistrarPushNotifications = async (uid) => {
  if (!Capacitor.isNativePlatform() || !uid || !currentToken) return;
  try {
    await updateDoc(doc(db, "roles", uid), {
      fcmTokens: arrayRemove(currentToken),
    });
  } catch (e) {
    console.error("Error removiendo token en logout:", e);
  }
};
